import React from 'react';
import {config, useNamedSelector} from 'helpers';

export function MembershipAlert({ title }) {
  const { webPlan, mobilePlan } = useNamedSelector('session.subscription');
  return webPlan != 'Free' && mobilePlan != 'Free' && (
    <div className="medium-spacing">
      { title &&
        <h4>You have a Premium Account</h4>
      }
      <p>
        Your Premium plan provides you full unlimited access to both the web and mobile applications.
        If you also have a { config.proPlan } subscription through your iTunes or Google account, you can cancel it.
      </p>
    </div>
  );
}
